import { apiHolder as api, getIsBase64Url } from 'api';
import { getImageFormatFromUrl, writeImagePng } from './get-img-from-url';
const fileApi = api.api.getFileApi();
export const handleCopyImg = async (imgNode, src = '', ext = 'png') => {
    if (src && getIsBase64Url(src)) {
        writeImagePng(src);
        return fileApi.clipboardWriteImage(src);
    }
    const imgDataURL = await getImageFormatFromUrl(src, `image/${ext}`);
    imgDataURL && fileApi.clipboardWriteImage(imgDataURL);
};
